function EndScreen({ text = "", buttonText = "", link = "" }) {
  return (
    <div id="h5vp_endscreen">
      <div className="overlay"></div>
      <div className="endscreen_content">
        <button>
          <span class="dashicons dashicons-visibility"></span>
          {buttonText}
        </button>
        <p>
          <a href={link}>{text}</a>
        </p>
      </div>
    </div>
  );
}

export default EndScreen;
